import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

// Our Components
import TrackingDrawer from '../../../pages/General/TrackingDrawer'
import Carrier from '../../General/Carrier'
import OrderStatus from '../../General/OrderStatus'
import Customer from '../../../pages/General/Customer'
import Filters from './Filters'
import Search from './Search'
import DynamicColumns from '../../../pages/General/DynamicColumns'
import Notification from '../../../pages/General/Notification'
import NorowsData from '../../../pages/General/NorowsData'
import IntegrationPlatform from '../../../pages/General/IntegrationPlatform'
import DateTime from '../../../pages/General/DateTime'
import NotificationDrawer from '../../../pages/General/NotificationDrawer'
import OrderDrawer from '../../../pages/General/OrderDrawer'
import EmailStatus from '../../General/EmailStatus'
import LinearProgress from '@mui/material/LinearProgress';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import _ from "lodash";
// mui components
import {
    Typography,
    FormControl,
    Pagination,
    IconButton,
    Tooltip,
    Avatar,
    Card,
    Box,
    Stack,
    Select,
    MenuItem
} from "@mui/material";
import { deepOrange, deepPurple } from '@mui/material/colors';
import Chip from '@mui/material/Chip';
import {
    DataGrid,
    GridToolbarContainer
} from '@mui/x-data-grid';
import {
    fetchNotificationReport, fetchNotificationpreview, fetchNotificationTotalIntegratedPlatform,
    fetchNotificationCategoriesCount, resendNotification, resetResendNotification
} from './notificationsSlice';

import {
    fetchOrderDetail
} from '../../../pages/OrderDetail/orderdetailsSlice';

import SearchIcon from '@mui/icons-material/Search';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import ViewColumnSharpIcon from '@mui/icons-material/ViewColumnSharp';
import KeyboardReturnOutlinedIcon from '@mui/icons-material/KeyboardReturnOutlined';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';

// Shared styling matrix map defining outlined controls focus layout behavior rings
const enterpriseInputSelectStyles = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #E2E8F0',
        '& fieldset': { border: 'none' },
        '&:hover': { borderColor: '#CBD5E1' },
        '&.Mui-focused': {
            borderColor: '#1976d2',
            boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
        }
    },
    '& .MuiSelect-select': {
        padding: '8px 14px !important',
        fontSize: '13px',
        color: '#1E293B',
        fontWeight: 500
    }
};

const notificationsPageUtilityIconStyles = (isActive) => ({
    color: '#1976d2',
    padding: '8px',
    borderRadius: '10px',
    backgroundColor: isActive ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
    border: isActive ? '1px solid rgba(25, 118, 210, 0.2)' : '1px solid #E2E8F0',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
        backgroundColor: isActive ? 'rgba(25, 118, 210, 0.12)' : 'rgba(241, 245, 249, 0.8)',
        borderColor: isActive ? 'rgba(25, 118, 210, 0.3)' : '#CBD5E1',
        transform: 'translateY(-1px)'
    },
    '&:active': { transform: 'translateY(0)' }
});

const NotificationsDashboardPage = () => {
    const dispatch = useDispatch();
    const report = useSelector((state) => state.notificationdashboard.report);
    const resend = useSelector((state) => state.notificationdashboard.resend);
    const [meta, setMeta] = useState(report.meta);
    const [showFilter, setShowFilter] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [trackingDrawerVisible, setTrackingDrawerVisible] = useState(false);
    const [orderDrawerVisible, setOrderDrawerVisible] = useState(false);

    const onMenuClick = (type, show) => {
        setShowSearch((type === "search" && show === true) ? true : false)
        setShowFilter((type === "filter" && show === true) ? true : false)
    }


    const onChangePerPage = (event) => {
        setMeta({
            ...meta,
            ...{
                page: 1,
                per_page: event.target.value
            }
        });
    }

    const onChangePagination = (event, page) => {
        setMeta({
            ...meta,
            ...{
                page: page
            }
        });
    }

    const trackingCallback = (item) => {
        console.log(item)
        dispatch(fetchNotificationpreview(item));
        setTrackingDrawerVisible(true)
    }

    const orderCallback = (item) => {
        dispatch(fetchOrderDetail(item));
        setOrderDrawerVisible(true)
    }
    const onClose = (values) => {
        setTrackingDrawerVisible(false);
    };

    const orderOnClose = (values) => {
        setOrderDrawerVisible(false);
    };
    const Emailresendnotification = (item) => {
        let data = { 'id': item }
        dispatch(resendNotification(data))
    };
    const columns = [
        {
            field: 'orderid',
            headerName: 'Order Id',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            renderCell: (params) => {
                return <span style={{ color: 'rgb(24, 144, 255)', cursor: 'pointer' }} onClick={e => { orderCallback(params.row.orderid) }}>{params.row.orderid}</span>
            }
        },
        {
            field: 'tracking_number',
            headerName: 'Tracking Number',
            headerClassName: 'super-app-theme--header',
            flex: 1
        },
        {
            field: 'created_at',
            headerName: 'Customer',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            renderCell: (params) => {
                if (!_.isUndefined(params.row.customer)) {
                    return (
                        <Customer name={params.row.customer.name} />
                    );
                } else {
                    return "-";
                }
            },
        },
        {
            field: 'platform',
            headerName: 'Platform',
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                if (!_.isUndefined(params.row.platform)) {
                    return <IntegrationPlatform platform={params.row.platform} />;
                } else {
                    return "-";
                }
            }
        },
        {
            field: 'event',
            headerName: 'Event',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            renderCell: (params) => {
                if (params.row.event && params.row.event && params.row.event !== "") {
                    return (
                        <OrderStatus orderStatus={params.row.event} />
                    )
                } else {
                    return <>-</>;
                }
            }
        },
        {
            field: 'status',
            headerName: 'Status',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            renderCell: (params) => {
                if (params.row.status && params.row.status !== "") {
                    return (
                        <EmailStatus emailStatus={params.row.status} />
                    )
                } else {
                    return <>-</>;
                }
            }
        },
        {
            field: 'updated_at',
            headerName: 'Date',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            renderCell: (params) => {
                if (!_.isUndefined(params.row.updated_at)) {
                    return <DateTime datetime={params.row.updated_at} />;
                } else {
                    return "-";
                }
            }
        },
        {
            field: 'preview',
            headerName: 'Action',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            renderCell: (params) => {
                if (params && params.row && params.row.platform !== 'EMAIL') {
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '100%' }}>
                            <Tooltip title="Preview" placement="top">
                                <IconButton 
                                    onClick={e => { trackingCallback(params.row._id) }}
                                    sx={{ 
                                        color: '#1976d2',
                                        padding: '6px',
                                        borderRadius: '8px',
                                        border: '1px solid #E2E8F0',
                                        backgroundColor: '#FFFFFF',
                                        '&:hover': { backgroundColor: '#F1F5F9', borderColor: '#CBD5E1' }
                                    }}
                                >
                                    <RemoveRedEyeIcon sx={{ fontSize: '18px' }} />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )
                } else {
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '100%' }}>
                            <Tooltip title="Preview" placement="top">
                                <IconButton 
                                    onClick={e => { trackingCallback(params.row._id) }}
                                    sx={{ 
                                        color: '#1976d2',
                                        padding: '6px',
                                        borderRadius: '8px',
                                        border: '1px solid #E2E8F0',
                                        backgroundColor: '#FFFFFF',
                                        '&:hover': { backgroundColor: '#F1F5F9', borderColor: '#CBD5E1' }
                                    }}
                                >
                                    <RemoveRedEyeIcon sx={{ fontSize: '18px' }} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Email Resend" placement="top">
                                <IconButton 
                                    onClick={e => { Emailresendnotification(params.row._id) }}
                                    sx={{ 
                                        color: '#1976d2',
                                        padding: '6px',
                                        borderRadius: '8px',
                                        border: '1px solid #E2E8F0',
                                        backgroundColor: '#FFFFFF',
                                        '&:hover': { backgroundColor: '#F1F5F9', borderColor: '#CBD5E1' }
                                    }}
                                >
                                    <KeyboardReturnOutlinedIcon sx={{ fontSize: '18px' }} />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )
                }
            }
        },
    ];



    function CustomTotalRows() {
        return (
            <Box 
                className="custom-total-rows"
                sx={{ 
                    display: 'inline-flex', 
                    alignItems: 'center',
                    py: 0.6,
                    px: 1.5,
                    borderRadius: '8px',
                    backgroundColor: '#F1F5F9', 
                    border: '1px solid #E2E8F0'
                }}
            >
                <Typography variant="body2" sx={{ fontSize: '12.5px', fontWeight: 600, color: '#475569' }}>
                    Showing <strong style={{ color: '#0F172A', fontWeight: 700 }}>{report && report.data && report.data.length}</strong> of <strong style={{ color: '#0F172A', fontWeight: 700 }}>{(report && report.meta && report.meta.total) ? report.meta.total : 0}</strong>
                </Typography>
            </Box>
        )
    }


    function CustomPagesizeoptions() {
        return (
            <Box className="custom-page-size-options" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                <Stack direction="row" spacing={1.2} alignItems="center">
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>Show</Typography>
                    <FormControl size="small" variant="outlined" sx={{ minWidth: 80, ...enterpriseInputSelectStyles }}>
                        <Select
                            value={meta && meta.per_page}
                            onChange={onChangePerPage}
                        >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                        </Select>
                    </FormControl>
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>entries</Typography>
                </Stack>
            </Box>
        )
    }

    function CustomToolbar() {
        return (
            <GridToolbarContainer
                sx={{
                    p: 2,
                    bgcolor: '#F8FAFC',
                    borderBottom: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                    width: '100%',
                    boxSizing: 'border-box'
                }}
            >
                <CustomPagesizeoptions />
                <CustomTotalRows />
            </GridToolbarContainer>
        );
    }

    function CustomPagination() {
        return (
            <Box
                sx={{
                    p: 1.5,
                    bgcolor: '#F8FAFC',
                    borderTop: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    width: '100%',
                    boxSizing: 'border-box',
                    '& .MuiPaginationItem-root': {
                        fontSize: '13px',
                        fontWeight: 600,
                        borderRadius: '8px',
                        '&.Mui-selected': {
                            backgroundColor: '#1976d2',
                            color: '#FFFFFF',
                            '&:hover': { backgroundColor: '#115293' }
                        }
                    }
                }}
            >
                <Pagination
                    color="primary"
                    shape="circular"
                    page={report && report.meta && report.meta.current_page}
                    count={report && report.meta && report.meta.last_page}
                    onChange={onChangePagination}
                />
            </Box>
        );
    }

    useEffect(() => {
        dispatch(fetchNotificationReport({ ...meta }));
    }, [meta]);

    return (
        <Box sx={{ width: '100%', boxSizing: 'border-box' }}>
            {(resend && resend.notification && resend.notification.showMessage) &&
                <Notification
                    is_open={resend.notification.showMessage}
                    messageType={resend.notification.messageType}
                    messages={resend.notification.messageContent}
                    handleClose={() => dispatch(resetResendNotification())}
                />}
                
            <Card 
                className="scmaincard"
                sx={{ 
                    width: '100%', 
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E2E8F0',
                    borderRadius: '16px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                    overflow: 'hidden'
                }}
            >
                <Box 
                    className="sccardhead"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        p: 2.5,
                        borderBottom: '1px solid #E2E8F0',
                        flexWrap: 'wrap',
                        gap: 2
                    }}
                >
                    <Typography 
                        variant="h5" 
                        component="h1" 
                        sx={{ 
                            fontWeight: 800, 
                            color: '#0F172A',
                            letterSpacing: '-0.5px',
                            margin: 0
                        }}
                    >
                        Notifications
                    </Typography>
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, p: 0, m: 0 }}>
                        <Tooltip title="Back to Platforms" placement="top">
                            <Link to="/integration/notification" style={{ textDecoration: 'none' }}>
                                <IconButton sx={notificationsPageUtilityIconStyles(false)}>
                                    <ArrowBackIosNewIcon sx={{ fontSize: '18px' }} />
                                </IconButton>
                            </Link>
                        </Tooltip>
                        <Tooltip title="Search Dashboard" placement="top">
                            <IconButton sx={notificationsPageUtilityIconStyles(showSearch)} onClick={() => onMenuClick("search", !showSearch)}>
                                <SearchIcon sx={{ fontSize: '20px' }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Filter Inbound Logs" placement="top">
                            <IconButton sx={notificationsPageUtilityIconStyles(showFilter)} onClick={() => onMenuClick("filter", !showFilter)}>
                                <FilterAltOutlinedIcon sx={{ fontSize: '20px' }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
                
                <Box>
                    <Search visible={showSearch} meta={meta} setMeta={setMeta} />
                    {showFilter && <Filters visible={showFilter} meta={meta} setMeta={setMeta} />}
                </Box>
                
                <Box sx={{ width: '100%', backgroundColor: '#FFFFFF' }}>
                    <DataGrid
                        sx={{
                            border: 'none',
                            backgroundColor: '#FFFFFF',
                            overflow: 'hidden',
                            '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC', '&::after': { display: 'none' } },
                            '& .MuiDataGrid-columnHeaders': { backgroundColor: '#F8FAFC', borderBottom: '1px solid #E2E8F0', minHeight: '52px !important', maxHeight: '52px !important' },
                            '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '13px', '&:focus, &:focus-within': { outline: 'none' } },
                            '& .MuiDataGrid-row': { transition: 'background-color 0.15s ease-in-out', borderBottom: '1px solid #F1F5F9', alignItems: 'center', '&:hover': { backgroundColor: '#F8FAFC' }, '&.Mui-selected': { backgroundColor: 'rgba(25, 118, 210, 0.04)', '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.08)' } } },
                            '& .MuiDataGrid-cell': { fontSize: '13.5px', color: '#334155', borderBottom: 'none', display: 'flex', alignItems: 'center', py: '12px', '&:focus, &:focus-within': { outline: 'none' } },
                            '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }
                        }}
                        getRowId={(row) => row._id}
                        rows={report && report.data}
                        columns={columns}
                        autoHeight={true}
                        disableColumnFilter={true}
                        disableColumnMenu={true}
                        sortingMode="server"
                        disableRowSelectionOnClick
                        slots={{
                            pagination: CustomPagination,
                            toolbar: CustomToolbar,
                            NorowsData,
                            loadingOverlay: LinearProgress,
                        }}
                        loading={report && report.loading}
                    />
                </Box>
            </Card>
            
            <NotificationDrawer visible={trackingDrawerVisible} onClose={onClose} />
            <OrderDrawer visible={orderDrawerVisible} onClose={orderOnClose} />
        </Box>
    )
}

export default NotificationsDashboardPage;